import { render, staticRenderFns } from "./i18n-select.vue?vue&type=template&id=50e565a8&"
import script from "./i18n-select.vue?vue&type=script&lang=js&"
export * from "./i18n-select.vue?vue&type=script&lang=js&"
import style0 from "./i18n-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QBtn,QMenu,QList,QItem,QItemSection,QItemLabel,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QBtn,QMenu,QList,QItem,QItemSection,QItemLabel})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
